<div class="flex flex-col flex-auto w-full h-full px-10 lt-md:px-0">
  <!-- logo edvisor -->
  <img
    class="m-auto xs:my-3 sm:my-4 md:my-5 lg:my-6 xl:my-7 w-10 lt-md:w-8 md:w-10 lg:w-12 xl:w-14"
    src="assets/logo-edvisor.svg"
    alt="edvisor"
    *ngIf="showLogo" />

  <!-- body stepper -->
  <!-- note: overflow-hidden was added to block scroll on delete component -->
  <!-- it's not affecting other modals -->
  <mat-horizontal-stepper
    [style.alignItems]="alignItems"
    class="scroll scroll-none overflow-hidden"
    [linear]="false"
    orientation="horizontal"
    #stepper>
    <div *ngFor="let step of steps">
      <mat-step *ngIf="!step.hide">
        <ng-container *ngTemplateOutlet="step.content"></ng-container>
      </mat-step>
    </div>
  </mat-horizontal-stepper>

  <!-- footer buttons -->
  <div
    class="flex lt-md:flex-col lt-md:items-center gap-3 justify-center mt-2 gt-sm:mt-4 mb-1 gt-sm:mb-3"
    *ngIf="viewInitialized">
    <button
      class="rounded-lg xs:w-full w-40"
      mat-stroked-button
      color="primary"
      (click)="
        stepper.previous(); currentIndex.next(myStepper.selectedIndex || 0)
      "
      *ngIf="
        viewInitialized &&
        ((sendIn == 'last' && myStepper.selectedIndex) ||
          (sendIn == 'penultimate' &&
            myStepper.selectedIndex &&
            myStepper.selectedIndex < this.visibleStepsLength - 1) ||
          error)
      ">
      {{
        previousButtonLabels[myStepper.selectedIndex] || 'shared:previous'
          | translate
      }}
    </button>

    <button
      class="rounded-lg xs:w-full w-40"
      mat-flat-button
      color="primary"
      (click)="stepper.next(); currentIndex.next(myStepper.selectedIndex || 0)"
      [disabled]="disabled"
      *ngIf="
        viewInitialized &&
        myStepper.selectedIndex <
          this.visibleStepsLength - (sendIn == 'last' ? 1 : 2)
      ">
      {{
        nextButtonLabels[myStepper.selectedIndex] || 'shared:next' | translate
      }}
    </button>

    <ng-container *ngIf="useCloseButton">
      <button
        class="rounded-lg xs:w-full w-40"
        mat-flat-button
        color="{{ classForCloseButton }}"
        (click)="closeDialog()"
        *ngIf="
          viewInitialized &&
          myStepper.selectedIndex ==
            this.visibleStepsLength - (sendIn == 'last' ? 1 : 2)
        ">
        {{ textForCloseButton | translate }}
      </button>
    </ng-container>

    <button
      class="rounded-lg xs:w-full w-40"
      mat-flat-button
      color="{{ classForSendButton }}"
      (click)="send.next(stepper); stepper.next()"
      [disabled]="disabled"
      *ngIf="
        viewInitialized &&
        myStepper.selectedIndex ==
          this.visibleStepsLength - (sendIn == 'last' ? 1 : 2)
      ">
      {{ textForSendButton | translate }}
    </button>
  </div>

  <!-- progress bar -->
  <mat-progress-bar
    class="dialog"
    [color]="'primary'"
    [value]="stepperProgress"
    [mode]="'determinate'"
    *ngIf="viewInitialized && progressBar"></mat-progress-bar>
</div>
